import { ReactElement, JSX } from 'react'

import { FeatureStatusTag } from 'components/FeatureStatusTag'
import { FeatureStatus } from 'components/FeatureStatusTag/FeatureStatusTag'
import { date } from 'configuration/dayjs'
import MetricTooltip, {
    MetricTooltipAlertType,
    MetricTooltipProps,
} from 'features/MetricsGlossary/components/MetricTooltip'
import { DataSource, DataSourceMetric } from 'features/MetricsGlossary/types'
import { elementToString } from 'helpers/utilities'
import { Field } from 'types'

interface MetricNameProps {
    field?: Field<any>
    metric?: DataSourceMetric
    dataSource?: DataSource
    tooltipAlertMessage?: ReactElement | string
    tooltipAlertType?: MetricTooltipAlertType
    tooltipZIndex?: number
    addTooltip?: boolean
    tooltipProps?: Partial<MetricTooltipProps>
}

function MetricName({
    field,
    metric,
    dataSource,
    tooltipAlertMessage,
    tooltipAlertType,
    tooltipZIndex,
    addTooltip = true,
    tooltipProps = {},
}: MetricNameProps): JSX.Element {
    const isDeprecated =
        metric?.metadata_is_deprecated ??
        field?.metricOptions?.isDeprecated ??
        false

    let featureStatus: FeatureStatus | undefined = isDeprecated
        ? 'deprecated'
        : undefined

    const metricReleaseDate =
        metric?.metadata_release_date ??
        field?.metricOptions?.releaseDate ??
        null

    if (!isDeprecated && !!metricReleaseDate) {
        const releaseDate = date(metricReleaseDate, 'YYYY-MM-DD')
        if (releaseDate.isAfter(date().subtract(3, 'month'))) {
            featureStatus = 'new'
        }
    }

    return !!metric && !!dataSource && addTooltip ? (
        <MetricTooltip
            {...tooltipProps}
            metric={metric}
            dataSource={dataSource}
            placement="right"
            alertMessage={tooltipAlertMessage}
            alertType={tooltipAlertType}
            zIndex={tooltipZIndex}
            customTooltip={field?.customToolTip}
        >
            <span>
                {elementToString(field?.name ?? '-')}
                {featureStatus && (
                    <>
                        {' '}
                        <FeatureStatusTag status={featureStatus} />
                    </>
                )}
            </span>
        </MetricTooltip>
    ) : (
        <>
            {elementToString(field?.name ?? '-')}
            {featureStatus && (
                <>
                    {' '}
                    <FeatureStatusTag status={featureStatus} />
                </>
            )}
        </>
    )
}

export default MetricName
